import * as actions from './actionTypes';
import { Notification } from 'api';

export interface INotification extends Notification {
	key: string;
}

export interface INotificationStore {
	notifications?: INotification[];
	seen: boolean;
}

const INITIAL_STATE: INotificationStore = {
	notifications: undefined,
	seen: true,
};

const Notifications = (
	state = INITIAL_STATE,
	action: { type: string; payload: any }
) => {
	switch (action.type) {
		case actions.GET_USER_NOTIFICATIONS_SUCCESS:
			state = {
				...state,
				seen: false,
				notifications: [...action.payload],
			};
			break;

		case actions.UPDATE_USER_NOTIFICATIONS:
			state = {
				notifications: [action.payload, ...action.payload],
				seen: false,
			};
			break;

		case actions.UPDATE_SEEN_STATUS:
			state = {
				...state,
				seen: action.payload,
			};
			break;

		case actions.RESET_USER_NOTIFICATIONS:
			state = { ...INITIAL_STATE };
			break;

		default:
			state = { ...state };
			break;
	}
	return state;
};

export default Notifications;
